import { render, staticRenderFns } from "./config-add-or-update.vue?vue&type=template&id=d56c4e78&"
import script from "./config-add-or-update.vue?vue&type=script&lang=js&"
export * from "./config-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports